<div class="img__edit--modal">
  <button type="button" class="btn btn-link" aria-label="Close" (click)="dismiss('Cross click')">
    <span class="icon icon-close"></span>
  </button>
  <div class="modal-body">
    <app-angular-cropper #angularCropper [imageUrl]="data" [cropperOptions]="{zoomable: true, aspectRatio: 1}" (export)="handleImport($event)"></app-angular-cropper>
  </div>
  <button class="btn btn-block btn-success" (click)="done()">Upload Photo</button>
</div>
